import { render } from "./BigFiveAskForm.vue?vue&type=template&id=4230ab9d&scoped=true"
import script from "./BigFiveAskForm.vue?vue&type=script&lang=js"
export * from "./BigFiveAskForm.vue?vue&type=script&lang=js"

import "./BigFiveAskForm.vue?vue&type=style&index=0&id=4230ab9d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4230ab9d"

export default script